import { attachLoadingSpinner } from './utilities/loading-spinner';

(function () {
  'use strict';
  const mediaHubFilterForm = document.getElementById('media-hub-filter');
  const exports = {

    initializeMediaHubFilter: function () {
      const checkboxes = mediaHubFilterForm.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function () {
          exports.submitFilterForm();
        });
      });
    },

    submitFilterForm: function() {
      const currentDownloadsList = document.querySelector('.c-downloads-list__container');
      currentDownloadsList.textContent = '';
      currentDownloadsList.insertAdjacentElement('afterbegin', attachLoadingSpinner(''));
      // Unset results counter
      const totalFiles = document.querySelector('[data-total-files]');
      totalFiles.textContent = '...';
      mediaHubFilterForm.submit();
    }

  };

  if (mediaHubFilterForm) {
    exports.initializeMediaHubFilter();
  }

})();
